module.exports = __webpack_public_path__ + "static/media/tablet-02.66c24df0.jpg";